<template>
  <div class="side-wrapper p-3">
    <div class="row">
      <div class="col-md-12">
        <div class="section-wrapper d-flex py-3">
       <div class="root-img d-flex" v-if="compliant">
              <img
                :src="$root.serverBasePath + '/verified.png'"
                alt="Strata Connex"
                height="40px"
              />

              <p class="ml-3 mb-0">
                Verified by Strata Connex<br />
                <span>100% Compliant</span>
              </p>
          </div>
          <div class="root-img d-flex" v-else>
              <i
                style="font-size: 40px"
                class="fas fa-exclamation-circle fa-2x unverified"
              ></i>

              <p class="ml-3 mb-0">Not Verified by Strata Connex<br /></p>
          </div>
          <!-- <div class="text-right" style="width: 50%">
            <i
              v-if="isAllLicensesVerified"
              class="fas fa-check-circle"
              style="font-size: 50px; color: rgb(0, 186, 136)"
            ></i>
            <i
              v-else
              class="fas fa-times-circle"
              style="font-size: 50px; color: rgb(237, 46, 126)"
            ></i>
          </div> -->
        </div>
      </div>
    </div>

    <div class="detail-section bg-white p-3">
      <div class="row">
        <div class="col-lg-12">
          <div
            v-for="(licence, index) in licence_info"
            :key="index"
            class="mb-2"
          >
            <div class="row">
              <div class="col-lg-12">
                <div class="license-head-text d-flex justify-content-between">
                  <div class="text-left">
                    <h4
                      v-if="licence.licence_type == 'trade_work'"
                    >
                      Trade Work Licence
                    </h4>

                    <h4
                      v-if="licence.licence_type == 'asbestos_and_high_risk'"
                    >
                    Asbestos & High Risk Licence
                    </h4>

                    <h4
                      v-if="licence.licence_type == 'security'"
                    >
                      Security Licence
                    </h4>

                    <h4
                      v-if="licence.licence_type == 'pesticide'"
                    >
                      Pesticide Licence
                    </h4>

                    <h4
                      v-if="licence.licence_type == 'fire_and_safety'"
                    >
                        FPA Australia accreditation
                    </h4>
                  </div>

                  <div class="text-right">
                    <SvgIcons
                      v-if="licence.licence_status == 'verified'"
                      icon="icon-verified"
                      width="25"
                      height="25"
                      svgClass="mb-1 ml-5 pull-right"
                    />
                    <SvgIcons
                      v-else
                      icon="icon-error"
                      width="25"
                      height="25"
                      svgClass="mb-1 ml-5 pull-right"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div v-if="licence.licence_status == 'verified'">
                <ul style="margin-bottom: 0;">
                    <li v-if="licence.jurisdictions">
                        <span class="title">Jurisdictions:</span>
                        <span class="sub-title">{{ licence.jurisdictions }}</span>
                    </li>

                    <li v-if="licence.licence_number">
                        <span class="title">Licence Number:</span>
                        <span class="sub-title">{{ licence.licence_number }}</span>
                    </li>

                    <li v-if="licence.start_date">
                        <span class="title">Start Date:</span>
                        <span class="sub-title">{{ momentDate(licence.start_date) }}</span>
                    </li>

                    <li v-if="licence.expiry_date">
                        <span class="title">Expiry Date:</span>
                        <span class="sub-title">{{  momentDate(licence.expiry_date) }}</span>
                    </li>

                    <li v-if="licence.associated_licence_type">
                        <span class="title">Licence Type:</span>
                        <span class="sub-title">{{ licence.associated_licence_type }}</span>
                    </li>

                    <li v-if="licence.class">
                        <span class="title">Class:</span>
                        <span class="sub-title">{{  licence.class }}</span>
                    </li>

                    <li v-if="licence.status">
                        <span class="title">Status:</span>
                        <span class="sub-title">{{ licence.status }}</span>
                    </li>

                    <li v-if="licence.condition">
                        <span class="title">Condition:</span>
                        <span class="sub-title">{{ licence.condition }}</span>
                    </li>
                </ul>

              <div v-if="licence.media.length > 0">
                <b-row>
                  <ul class="ml-3">
                    <li>
                      <span class="title">Documents:</span>
                      <span class="sub-title" v-for="(file, idx2) in licence.media" :key="'qp-file' + '-' + idx2">
                        <a :href="file.signed_url" target="_blank">
                          {{ file.name }}
                        </a>
                      </span>
                    </li>
                  </ul>
                </b-row>
              </div>

            </div>
            <div v-else>Sorry, Licence details not verified yet.</div>
          </div>
        </div>
        <div class="col-lg-12">
          <b-button
            :to="{ name: 'contractor-compliance' }"
            type="button"
            variant="outline-primary"
            >Close</b-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import moment from "moment";
import SvgIcons from "@frontend/pages/includes/SvgIconsComponent.vue";

export default {
  components: {
    moment,
    SvgIcons,
  },
  data() {
    return {
      licence_info: {},
      licence_info_loaded: false,
      compliant: false,
    };
  },
  mounted() {
    this.getDetails();
    this.checkComplaint();
  },
  methods: {
    getDetails() {
      this.$root.$data.bsLoader = true;
      axios
        .post("api/contractor/compliance/getLicenceDetails")
        .then((response) => {
          this.licence_info = response.data.licence_info;
          this.licence_info_loaded = true;
          this.$root.$data.bsLoader = false;
        });
    },
    checkComplaint() {
      axios.post("api/contractor/compliance/checkCompliant").then((response) => {
        if(response.data.check_compliant){
          this.compliant = true;
        }
      });
    },
    fetchAbnAcnDetails() {
      axios
        .post("api/contractor/compliance/fetchAbnAcnDetails")
        .then((response) => {
          this.getDetails();
        });
    },
    momentDate: function (date) {
      return moment(date).format("D MMM YYYY");
    },
  },
  computed: {
    isAllLicensesVerified() {
      let verified = true;
      this.licence_info_loaded &&
        this.licence_info.forEach((data) => {
          if (data.licence_status != "verified") {
            verified = false;
          }
          //   //return verified = verified && (data.licence_status == 'verified');
        });
      return verified;
    },
  },
};
</script>

<style scoped>
.side-wrapper {
  background-color: #eff0f6;
  min-height: 100vh;
}
.unverified {
  color:#e83e8c;
}
</style>
